import type { Movimiento } from "../api/tipos.ts";
import { esDeCerteza } from "../api/tipos.ts";
import { esElMontoBuscado, instanteDe, montoBuscado } from "../formato.ts";

/**
 * La caja (SPEC-029 §12): la pregunta del cajero es una sola, «¿ya llegó la
 * plata de este cliente?», y la hace con el cliente delante.
 */

/** El día de hoy en el reloj de quien mira, como lo escribe el banco: «2026-10-01». */
export function hoyLocal(ahora = new Date()): string {
  const dd = (n: number) => String(n).padStart(2, "0");
  return `${ahora.getFullYear()}-${dd(ahora.getMonth() + 1)}-${dd(ahora.getDate())}`;
}

/**
 * Lo que se ve en la caja.
 *
 * Sin buscar: lo que entró hoy, del más nuevo al más viejo. Buscando un monto:
 * ese monto en cualquier día —el cliente pudo pagar ayer—. Buscando texto:
 * quién pagó o a quién se le atribuyó.
 */
export function pagosDeCaja(movimientos: Movimiento[], q: string, hoy = hoyLocal()): Movimiento[] {
  const t = q.trim().toLowerCase();
  const filtrados = !t
    ? movimientos.filter((m) => String(m.fecha ?? "").slice(0, 10) === hoy)
    : montoBuscado(t) !== null
      ? movimientos.filter((m) => esElMontoBuscado(t, m.montoCentavos))
      : movimientos.filter((m) =>
          [m.contraparte, m.cliente].some((v) => String(v ?? "").toLowerCase().includes(t)),
        );
  return [...filtrados].sort((a, b) => instanteDe(b.fecha) - instanteDe(a.fecha));
}

/** Una sola palabra de estado: lo que el cajero necesita para entregar o no. */
export const listo = (m: Movimiento) => esDeCerteza(m.estado);
